"use strict";
/* globals module */
/**
 * @module calendarEventRsvpAttendeeStatusClient
 * @description  CalendarEventRsvpAttendeeStatus Client provides an easy way to consume CalendarEventRsvpAttendeeStatus REST API end-points. In order to obtain needed routes `calendarEventRsvpAttendeeStatusClient` uses `calendarEventRsvpAttendeeStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarEventRsvpAttendeeStatusClient = /** @class */ (function () {
    function CalendarEventRsvpAttendeeStatusClient(calendarEventRsvpAttendeeStatusBatchclient, calendarEventRsvpAttendeeStatusRoute, apiClient) {
        this.calendarEventRsvpAttendeeStatusBatchclient = calendarEventRsvpAttendeeStatusBatchclient;
        this.calendarEventRsvpAttendeeStatusRoute = calendarEventRsvpAttendeeStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpAttendeeStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpAttendeeStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventRsvpAttendeeStatusClient.prototype, "batch", {
        get: function () {
            return this.calendarEventRsvpAttendeeStatusBatchclient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventRsvpAttendeeStatus resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventRsvpAttendeeStatus resource.
     * @method
     * @param id CalendarEventRsvpAttendeeStatus id which uniquely identifies CalendarEventRsvpAttendeeStatus resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.get()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvpAttendeeStatus action has been performed. This action creates a new CalendarEventRsvpAttendeeStatus resource.
     * @method
     * @param data A CalendarEventRsvpAttendeeStatus object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvpAttendeeStatus action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvpAttendeeStatus action has been performed. This action updates a CalendarEventRsvpAttendeeStatus resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpAttendeeStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventRsvpAttendeeStatus object used to update specified CalendarEventRsvpAttendeeStatus resource.
     * @returns A promise that is resolved once the update CalendarEventRsvpAttendeeStatus action has been performed.
     * @example calendarEventRsvpAttendeeStatus is a resource previously fetched using get action.
                calendarEventRsvpAttendeeStatus.name = '<name>';
                calendarEventRsvpAttendeeStatusClient.update(calendarEventRsvpAttendeeStatus)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventRsvpAttendeeStatus resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpAttendeeStatusRsvpAttendeeStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventRsvpAttendeeStatus object used to delete specified CalendarEventRsvpAttendeeStatus resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpAttendeeStatus is a resource previously fetched using get action.
                calendarEventRsvpAttendeeStatusClient.remove(calendarEventRsvpAttendeeStatus)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventRsvpAttendeeStatus resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventRsvpAttendeeStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpAttendeeStatusBatchClient !== "undefined" && __1.CalendarEventRsvpAttendeeStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventRsvpAttendeeStatusRoute !== "undefined" && __1.CalendarEventRsvpAttendeeStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventRsvpAttendeeStatusClient);
    return CalendarEventRsvpAttendeeStatusClient;
}());
exports.CalendarEventRsvpAttendeeStatusClient = CalendarEventRsvpAttendeeStatusClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
